'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.41 12.712c.125 0 .241.072.297.185l3.767 7.623a.332.332 0 0 1-.298.48H2.332a.332.332 0 0 1-.298-.48l3.767-7.623.596.295-3.53 7.143h17.774l-3.438-6.958h-6.419v-.665h6.625Zm-.317 2.334.685.685-3.69 3.69-1.866-1.869.685-.685 1.182 1.183 3.004-3.004Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.49 16.777c.183 0 .332.149.332.333v1.648h1.213v.665H4.64v-.665h1.213V17.11c0-.184.148-.333.332-.333Zm-.333.665h-3.64v1.316h3.64v-1.316Zm8.46-11.27c.182 0 .331.15.331.333v1.781a.333.333 0 0 1-.332.333H10.03l.01 7.492-.665.001-.002-1.72h-1.88l1.346 1.58-.337.288L7.3 14.848l.001 1.263-.664.001-.01-7.493H3.361a.332.332 0 0 1-.332-.333v-1.78c0-.185.148-.334.332-.334Zm-9.249 5.713L7.51 13.948h1.861l-.003-2.063Zm-.203-.435h-1.87l.002 2.072 1.868-2.072ZM7.291 8.928l.003 2.078h1.871L7.291 8.928Zm2.073-.309H7.61l1.757 1.95-.003-1.95Zm7.863-1.475-1.06.81h2.116v-.003l-1.056-.807ZM3.693 7.4v.555h.726L3.693 7.4Zm10.758-.255-1.058.81h2.118l-1.06-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.057.81h2.116l-1.059-.81Zm-.327-.307H3.693v.004l1.054.806 1.058-.81Zm11.094 0h-2.12l1.06.81 1.06-.81Zm-2.775 0h-2.118l1.06.81 1.058-.81Zm-2.773 0H9.233l1.06.81 1.058-.81Zm-2.774 0H6.46l1.058.81 1.06-.81Zm9.706 0h-.728l.728.556v-.556ZM8.122 3.001l.078.015 6.97 2.25-.205.634-6.804-2.198L5.34 5.848l-.402-.53 2.96-2.25a.332.332 0 0 1 .303-.052Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0Cultivable = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Cultivable = FwSet0Cultivable;